import { RunbookResponse } from "@pufflig/prompt-studio-types";
import { PromptbookEditorRef } from "@pufflig/promptbook-editor";
import { PromptbookWebRuntime } from "@pufflig/promptbook-runtime";

/**
 * Update the runbook state based on the response from the server.
 * If the response contains an interrupt, it will handle the interrupt.
 *
 * @param parsedData
 * @param ref
 * @returns
 */
export const handleRunbookResponse = async (
  parsedData: RunbookResponse,
  _runtime: PromptbookWebRuntime,
  _connection: WebSocket,
  ref: React.RefObject<PromptbookEditorRef>,
) => {
  const { type, interrupt, runstate, threadId, isDone = false } = parsedData;

  if (type !== "runbook_response" || interrupt) return;

  ref.current?.handleStateUpdate(runstate, { threadId, isDone });
};
